import React, { useEffect, useState } from 'react';
import Errors from '../../../components/errors';
import Loader from '../../../components/loader';
import Form from './form';
import { map } from 'lodash';

const ImageTypeContainer = ({ title, featureToggle, onSave, isLoading, error, readOnly, users }:any) => {

    const [isEnabled, setIsEnabled] = useState(false);
    
    const [selectedUsers, setSelectedUsers] = useState<any[]>([]);
        
        useEffect(() => {
        if (!isLoading && featureToggle) {
    //        setEnabledUserIds(featureToggle.enabledUserIds);
            setIsEnabled(featureToggle.isEnabled);
            setSelectedUsers(featureToggle.enabledUserIds.map((id: number) => {
                const user = users.find((user: any) => user.id === id);
                return { value: id, label: user?.name + " (" + user?.emailAddress + ")" };
            }));
        }
    },[isLoading, featureToggle]);

    const onUpdateFeatureToggle = (e: any) => {
        e.preventDefault();        
        onSave({isEnabled, enabledUserIds: selectedUsers.map((user: any) => user.value)});
      };
          
    return (
        <section className="section">
            <div>
                <h1>{title}</h1>
                <Errors error={error}/>
                {isLoading && <Loader/>}

                {!isLoading && <Form name={featureToggle?.name}
                    setIsEnabled={setIsEnabled}
                    setSelectedUsers={setSelectedUsers}
                    onSave={onUpdateFeatureToggle}                    
                    readOnly={readOnly}          
                    isEnabled={isEnabled}
                    selectedUsers={selectedUsers}    
                    users={users}                
                    />
                }
            </div>
        </section>
    )    
};

export default ImageTypeContainer;